/**
 * Set the current page
 *
 * Will trigger new search
 *
 * @param current Integer
 */
export default function setCurrent(current) {
  var _console;

  // eslint-disable-next-line no-console
  if (this.debug) (_console = console).log.apply(_console, ["Action", "setCurrent"].concat(Array.prototype.slice.call(arguments)));

  this._updateSearchResults({
    current: current
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldEN1cnJlbnQuanMiXSwibmFtZXMiOlsic2V0Q3VycmVudCIsImN1cnJlbnQiLCJkZWJ1ZyIsImNvbnNvbGUiLCJsb2ciLCJhcmd1bWVudHMiLCJfdXBkYXRlU2VhcmNoUmVzdWx0cyJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7QUFPQSxlQUFlLFNBQVNBLFVBQVQsQ0FBb0JDLE9BQXBCLEVBQTZCO0FBQUE7O0FBQzFDO0FBQ0EsTUFBSSxLQUFLQyxLQUFULEVBQWdCLFlBQUFDLE9BQU8sRUFBQ0MsR0FBUixrQkFBWSxRQUFaLEVBQXNCLFlBQXRCLG9DQUF1Q0MsU0FBdkM7O0FBRWhCLE9BQUtDLG9CQUFMLENBQTBCO0FBQ3hCTCxJQUFBQSxPQUFPLEVBQVBBO0FBRHdCLEdBQTFCO0FBR0QiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFNldCB0aGUgY3VycmVudCBwYWdlXG4gKlxuICogV2lsbCB0cmlnZ2VyIG5ldyBzZWFyY2hcbiAqXG4gKiBAcGFyYW0gY3VycmVudCBJbnRlZ2VyXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldEN1cnJlbnQoY3VycmVudCkge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8tY29uc29sZVxuICBpZiAodGhpcy5kZWJ1ZykgY29uc29sZS5sb2coXCJBY3Rpb25cIiwgXCJzZXRDdXJyZW50XCIsIC4uLmFyZ3VtZW50cyk7XG5cbiAgdGhpcy5fdXBkYXRlU2VhcmNoUmVzdWx0cyh7XG4gICAgY3VycmVudFxuICB9KTtcbn1cbiJdfQ==